// extracted by mini-css-extract-plugin
export default {"codeEditor":"codeEditor--dfVUa","border":"border--KdQJ3"};